import { createModel } from "@rematch/core";
import { RootModel } from ".";
import { MinimalChannelResource } from "@/types/resources";

interface ChannelsFilterAttributes {
  channelsFrom: MinimalChannelResource[];
  channelsTo: MinimalChannelResource[];
  lastReleaseFrom: string;
  lastReleaseTo: string;
}

interface State {
  projectsChannelsFilter: {
    [teamId: string]: ChannelsFilterAttributes;
  };
}

const initialState: State = {
  projectsChannelsFilter: {},
};

const DEFAULT_CHANNELS_FILTER_STATE: ChannelsFilterAttributes = {
  channelsFrom: [],
  channelsTo: [],
  lastReleaseFrom: "",
  lastReleaseTo: "",
};

export const distribution = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setProjectsChannelsFilter(
      state,
      payload: {
        teamId: string;
        attributes: ChannelsFilterAttributes;
      }
    ) {
      return {
        ...state,
        projectsChannelsFilter: {
          ...state.projectsChannelsFilter,
          [payload.teamId]: payload.attributes,
        },
      };
    },
    resetProjectsChannelsFilter(state, teamId: string) {
      return {
        ...state,
        projectsChannelsFilter: {
          ...state.projectsChannelsFilter,
          [teamId]: {
            ...DEFAULT_CHANNELS_FILTER_STATE,
          },
        },
      };
    },
  },
});
